import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: [AsyncPipe]
})
export class FooterComponent implements OnInit {

    private baseUrl = environment.S2EMULATOR_API_ENDPOINT;

    currentYear!: number;
    version$ = this.getAppVersion();

    constructor(private http: HttpClient) {}

    ngOnInit(): void {
        this.currentYear = new Date().getFullYear();
    }

    getAppVersion() {
        return this.http.get(`${this.baseUrl}/app-version`, { responseType: 'text' });
    }

}
